import { Link } from 'react-router-dom';

const ColoredLink = ({ color, ...props }) => (
  <Link
    className={`colored-link text-color-${color}`}
    {...props}
  />
);

export default ColoredLink;
